<template>
  <div id="login">
    <div class="login-container">
      <!-- 品牌区域 -->
      <div class="brand-section">
        <div class="logo">
          <i class="el-icon-cpu"></i>
        </div>
        <h1 class="brand-title">运维练兵场</h1>
      </div>

      <!-- 登录表单 -->
      <div class="form-section">
        <div class="form-header">
          <h3>用户登录</h3>
        </div>

        <el-form ref="loginForm" :model="loginForm" class="login-form">
          <div class="input-group">
            <label class="input-label">
              <i class="el-icon-message"></i>
              邮箱地址
            </label>
            <el-input 
              v-model.trim="loginForm.email" 
              placeholder="请输入您的邮箱"
              size="large"
              class="modern-input"
            >
              <template #prefix>
                <i class="el-icon-user"></i>
              </template>
            </el-input>
          </div>

          <div class="input-group">
            <label class="input-label">
              <i class="el-icon-lock"></i>
              密码
            </label>
            <el-input 
              type="password" 
              v-model.trim="loginForm.password" 
              placeholder="请输入密码"
              size="large"
              class="modern-input"
              show-password
            >
              <template #prefix>
                <i class="el-icon-key"></i>
              </template>
            </el-input>
          </div>

          <!-- 功能链接 -->
          <div class="form-links">
            <el-link 
              class="forgot-password" 
              type="info" 
              href="/faq"
              :underline="false"
            >
              <i class="el-icon-question"></i>
              忘记密码?
            </el-link>
            <el-link 
              type="primary" 
              href="/register"
              :underline="false"
            >
              <i class="el-icon-user"></i>
              注册新账号
            </el-link>
          </div>

          <!-- 登录按钮 -->
          <el-button 
            type="primary" 
            @click="login" 
            class="login-btn"
            :loading="loading"
            size="large"
          >
            <i class="el-icon-position"></i>
            {{ loading ? '登录中...' : '立即登录' }}
          </el-button>
        </el-form>
      </div>

      <!-- 平台特性展示 -->
      <div class="features-section">
        <div class="features-grid">
          <div class="feature-item">
            <div class="feature-icon">
              <i class="el-icon-cpu"></i>
            </div>
            <div class="feature-content">
              <p>分钟级启动运维演示/练习/POC环境</p>
            </div>
          </div>
          <div class="feature-item">
            <div class="feature-icon">
              <i class="el-icon-coin"></i>
            </div>
            <div class="feature-content">
              <p>按分钟/小时计费</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { ElMessage } from "element-plus";

export default {
  name: "LoginPage",
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      loading: false
    };
  },
  mounted() {
    // 添加键盘事件监听
    document.addEventListener('keypress', this.handleKeyPress);
  },
  beforeUnmount() {
    document.removeEventListener('keypress', this.handleKeyPress);
  },
  methods: {
    handleKeyPress(event) {
      // 回车键登录
      if (event.key === 'Enter' && !this.loading) {
        this.login();
      }
    },
    getApiHost() {
      const hostname = window.location.hostname;
      if (hostname === 'sre.azlinux.com' || hostname === 'cn.sre.azlinux.com') {
        return 'sre.azlinux.com';
      }
      return 'sre.azlinux.com';
    },
    async login() {
      // 输入验证
      if (!this.validateForm()) {
        return;
      }

      this.loading = true;

      try {
        const response = await axios.post(`/api/login`, this.loginForm);
        const { email } = response.data.data;

        // JWT 由服务端写入 HttpOnly Cookie，浏览器脚本无法读取。
        localStorage.setItem("email", "sre-" + email);

        ElMessage({
          message: "登录成功，正在跳转到用户中心...",
          type: "success",
          duration: 2000,
          offset: 240,
        });

        setTimeout(() => {
          window.location.href = "/user-center";
        }, 1000);

      } catch (error) {
        console.error("Login failed:", error);
        this.handleLoginError(error);
      } finally {
        this.loading = false;
      }
    },
    validateForm() {
      const { email, password } = this.loginForm;

      // 邮箱格式验证
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        ElMessage({
          message: "请输入有效的邮箱地址",
          type: "error",
          duration: 2000,
          offset: 240,
        });
        return false;
      }

      // 长度验证
      if (email.length < 5 || email.length > 50) {
        ElMessage({
          message: "邮箱长度必须在 5 到 50 个字符之间",
          type: "error",
          duration: 2000,
          offset: 240,
        });
        return false;
      }

      if (password.length < 8 || password.length > 128) {
        ElMessage({
          message: "密码长度必须在 8 到 128 个字符之间",
          type: "error",
          duration: 2000,
          offset: 240,
        });
        return false;
      }

      return true;
    },
    handleLoginError(error) {
      const errorMessage = error.response && error.response.data.message
        ? error.response.data.message
        : "登录失败！请检查输入，稍后重试。";

      ElMessage({
        message: errorMessage,
        type: "error",
        duration: 2000,
        offset: 240,
      });
    }
  },
};
</script>

<style scoped>
#login {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f0f2f5;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* 登录容器 */
.login-container {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  width: 420px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  animation: slideUp 0.6s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 品牌区域 */
.brand-section {
  text-align: center;
  margin-bottom: 32px;
}

.logo {
  width: 70px;
  height: 70px;
  background: #409eff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  color: white;
  font-size: 28px;
  box-shadow: 0 6px 16px rgba(30, 60, 114, 0.3);
}

.brand-title {
  font-size: 22px;
  font-weight: 600;
  color: #1e3c72;
  margin: 0 0 8px 0;
}

/* 表单区域 */
.form-header {
  text-align: center;
  margin-bottom: 32px;
}

.form-header h3 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.form-header p {
  color: #666;
  font-size: 14px;
  margin: 0;
}

/* 输入框组 */
.input-group {
  margin-bottom: 24px;
}

.input-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  margin-bottom: 8px;
}

.modern-input {
  border-radius: 8px;
}

.modern-input:deep(.el-input__wrapper) {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.modern-input:deep(.el-input__wrapper.is-focus) {
  box-shadow: 0 2px 8px rgba(30, 60, 114, 0.2);
  border-color: #1e3c72;
}

/* 表单链接 */
.form-links {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.form-links .el-link {
  font-size: 13px;
  display: flex;
  align-items: center;
  gap: 4px;
}

/* 登录按钮 */
.login-btn {
  width: 100%;
  height: 44px;
  border-radius: 8px;
  background: #409eff;
  border: none;
  font-weight: 500;
  font-size: 15px;
  box-shadow: 0 4px 12px rgba(30, 60, 114, 0.3);
  transition: all 0.3s ease;
  margin-bottom: 24px;
}

.login-btn:hover {
  background: #79bbff;
  box-shadow: 0 6px 16px rgba(30, 60, 114, 0.4);
}

/* 特性展示 */
.features-section {
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
}

.features-grid {
  display: grid;
  gap: 16px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border-radius: 8px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.feature-item:hover {
  background: #f0f2f5;
}

.feature-icon {
  width: 36px;
  height: 36px;
  background: #79bbff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 16px;
}

.feature-content h4 {
  margin: 0 0 4px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.feature-content p {
  margin: 0;
  font-size: 12px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-container {
    width: 90%;
    padding: 30px 24px;
    margin: 20px;
  }
  
  .brand-title {
    font-size: 20px;
  }
}
</style>
